(function ($) {
  Drupal.behaviors.stickyNodeV1 = {
    attach: function (context) {
      var $stickyNode = $('.js-sticky-node', context);
      var $stickyNodeContent = $stickyNode.find('.sticky-node-content', context);
      var $mppMenu = $('.js-mpp-menu', context);

      $(document).on('menu:anchored_update', function () {
        var baseLink = window.location.pathname + window.location.search;

        if ($mppMenu.length > 0) {
          $mppMenu.removeClass('menu-active');
          $mppMenu.each(function () {
            var $this = $(this);
            var menuLink = $this.attr('href');

            if (baseLink === menuLink) {
              $this.addClass('menu-active');
            }
          });
        }
      });

      if ($stickyNodeContent.length) {
        var contentHeight = $stickyNodeContent.height();

        $stickyNode.css('height', contentHeight);
      }
      $(window).on(
        'scroll',
        _.throttle(function () {
          var scrollTop = $(window).scrollTop();
          var scrollPoint = $stickyNode.attr('scroll-point');

          if (scrollTop > scrollPoint) {
            $stickyNodeContent.addClass('filter-fixed-top');
          } else {
            $stickyNodeContent.removeClass('filter-fixed-top');
          }
        }, 500)
      );
    }
  };
})(jQuery);
